export {
	BoardCellNumV8,
	SharecodeMaxTalentsV8,
	SharecodeMaxUnequippedItemsV8,
	EquippedItemV8,
	ShareCodeV8,
} from "./sharecodes/v8";

export const CurrentShareCodeVersion = 8;
